import * as d3 from 'd3';
import * as _ from 'lodash';

export interface ICompilableScope extends angular.IScope {
    series: { attributes?: { compile: string } }[];
}

export interface IDynamicCompileService {
    compileGroup(element: angular.IAugmentedJQuery, scope: ICompilableScope, callback?: () => void, series?: any[]);
}

export class DynamicCompileService implements IDynamicCompileService {
    constructor(private _$compile: angular.ICompileService, private _$timeout: angular.ITimeoutService) {

    }

    compileGroup(element: angular.IAugmentedJQuery, scope: ICompilableScope, callback?: () => void, series?: any[]) {
        try {
            const compileDirectives = _.chain(series || <any[]>scope.series)
                .filter(s => s.attributes)
                .map(s => s.attributes.compile)
                .uniq()
                .value();
            if (compileDirectives.length > 0) {
                const self = this;
                compileDirectives.forEach(c => {
                    const kids = d3.select(element[0]).selectAll(`[compile=${c}]`);
                    kids.each(function () {
                        const sel = d3.select(this);
                        // nothing is setting compiled to false, we can't rely on it
                        if (!sel.attr('compiled')) {
                            self._$compile(this)(scope);
                            sel.attr('compiled', true);
                        }
                    });
                });
            }

            if (callback) {
                this._$timeout(() => callback());
            }
        } catch (e) {
            console.error(e);
        }
    }
}
